import * as React from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { LightTooltip } from '@sales-center/components'
import { useBoolean } from '@sales-center/common'
import { useTheme } from '@mui/material/styles'

export default function SearchToolTip() {
  const { state, onToggle } = useBoolean()
  const theme = useTheme()
  return (
    <>
      <Typography variant="body2" color={theme.palette.text.primary} mb="12px">
        We made some improvements to the search. View{' '}
        <LightTooltip
          open={state}
          onClose={onToggle}
          onOpen={onToggle}
          tooltipWidth="500px"
          tooltipShadow={5}
          title={
            <>
              <Stack px={'16px'} py={'4px'} pb={2}>
                <Typography
                  marginTop={2}
                  marginBottom={2.5}
                  color={theme.palette.text.primary}
                  variant="body2"
                  fontWeight={400}
                  sx={{ fontSize: '1.1rem' }}
                >
                  Search Tips
                </Typography>

                <Typography
                  color={theme.palette.text.primary}
                  variant="body2"
                  display="flex"
                >
                  <Typography
                    color={theme.palette.text.primary}
                    variant="subtitle2"
                    fontWeight={500}
                    width="130px"
                  >
                    Customer name:
                  </Typography>
                  Use only last name, “Solomon”
                </Typography>
                <Typography
                  color={theme.palette.text.primary}
                  variant="body2"
                  display="flex"
                >
                  <Typography
                    color={theme.palette.text.primary}
                    variant="subtitle2"
                    fontWeight={500}
                    width="130px"
                  >
                    Phone:
                  </Typography>
                  Use xxx-xxx-xxxx format
                </Typography>
                <Typography
                  color={theme.palette.text.primary}
                  variant="body2"
                  display="flex"
                >
                  <Typography
                    color={theme.palette.text.primary}
                    variant="subtitle2"
                    fontWeight={500}
                    width="130px"
                  >
                    Address:
                  </Typography>
                  Use number and street, “382 West 15th Ave”
                </Typography>
                <Typography
                  color={theme.palette.text.primary}
                  variant="body2"
                  display="flex"
                >
                  <Typography
                    color={theme.palette.text.primary}
                    variant="subtitle2"
                    fontWeight={500}
                    width="130px"
                  >
                    Email:
                  </Typography>
                  Use address@domain.com format
                </Typography>
                <Typography
                  color={theme.palette.text.primary}
                  variant="body2"
                  display="flex"
                >
                  <Typography
                    color={theme.palette.text.primary}
                    variant="subtitle2"
                    fontWeight={500}
                    width="130px"
                  >
                    Location Number:
                  </Typography>
                  Search using an exact bill-to location code
                </Typography>
                <Typography
                  color={theme.palette.text.primary}
                  variant="body2"
                  display="flex"
                >
                  <Typography
                    color={theme.palette.text.primary}
                    variant="subtitle2"
                    fontWeight={500}
                    width="130px"
                  >
                    Operators:
                  </Typography>
                  Use “OR” to increase search results, “John OR Smith”
                </Typography>
              </Stack>
            </>
          }
        >
          <Typography
            variant="subtitle4"
            color={theme.palette.primary.main}
            mb="12px"
            sx={{ cursor: 'pointer' }}
          >
            Search Tips
          </Typography>
        </LightTooltip>{' '}
        to learn how to get better results.
      </Typography>
    </>
  )
}
